import React, { useEffect } from "react";
import { Container, Row, Col, Input } from 'reactstrap';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import AppBreadcrumb from '../../../components/ui/AppBreadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import { Link } from "react-router-dom";
import { CREATE_PROCEDURE, DELETE_PROCEDURE, PROCEDURE_DETAILS } from '../../../navigation/ROUTE_CONSTANTS';
import { setNavigateTo } from "../../../redux/actions/ui.actions";
import { clearSelectedProcedure, getAdminListProcedures } from "../../../redux/actions/procedures.actions";
import { customStyles } from '../../../theme/assets/dataTableCustomStyles';

const Procedures = () => {

    const adminProceduresList = useSelector((state) => state.adminProcedures.adminProceduresList);
    const isRoleClientAdmin = useSelector((state) => state.users.isRoleClientAdmin);

    const dispatch = useDispatch();

    const createProcedure = () => {
        dispatch(setNavigateTo(CREATE_PROCEDURE));
    }

    useEffect(() => {
        document.title = process.env.REACT_APP_SITE_TITLE + ' - Procedures';
        dispatch(getAdminListProcedures());
        dispatch(clearSelectedProcedure());
    }, [dispatch]);

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            cell: (row) => (
                <Link to={PROCEDURE_DETAILS.replace(':procedureId', row.id)} className='text-decoration-none'>
                    {row.name}
                </Link>),

            width: '50%'
        },
        {
            name: 'Short name',
            selector: row => row.short_name,
            sortable: true,
        },
        {
            name: 'Need details',
            center: true,
            cell: (row) => (<Input type='checkbox' defaultChecked={row.need_details} disabled />)
        },
        {
            name: 'Actions',
            center: true,
            cell: (row) => (<>
                {isRoleClientAdmin && <>
                    <Link className='text-dark btn btn-link btn-light' to={PROCEDURE_DETAILS.replace(':procedureId', row.id)} >
                        <FontAwesomeIcon icon={faPen} title="Edit" />
                    </Link>
                    <Link className='text-dark btn btn-link btn-light' to={DELETE_PROCEDURE.replace(':procedureId', row.id)} >
                        <FontAwesomeIcon icon={faTrash} title="Delete" />
                    </Link>
                </>
                }
            </>),
        }
    ];

    return (
        <Container className="min-vh-72">
            <Row>
                <Col>
                    <AppBreadcrumb headText="Procedures" />
                </Col>
            </Row>
            <Row>
                <Col>
                </Col>
            </Row>
            <Row className='pb-1 mb-2 mt-2'>
                <Col md={3}>
                    <h3 className='mb-4 mt-2'>Procedures</h3>
                </Col>
                <Col md={{ offset: 6, size: 3 }}>
                    {isRoleClientAdmin && <Button color={'success'} onClick={createProcedure} block>
                        Create new procedure
                    </Button>}
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    {adminProceduresList && adminProceduresList.length === 0 ? (
                        <div className="alert alert-primary mt-2">
                            Empty list
                        </div>
                    ) : (
                        <DataTableExtensions filter={true} export={false} print={false} filterPlaceholder="Search procedure"
                            columns={columns}
                            data={adminProceduresList} >
                            <DataTable
                                columns={columns}
                                data={adminProceduresList}
                                noHeader
                                pagination
                                highlightOnHover
                                customStyles={customStyles}
                            />
                        </DataTableExtensions>
                    )}
                </Col >
            </Row>
        </Container>
    )
};

export default Procedures;